import React from 'react'
import { Link } from 'react-router-dom'
import Styled from 'styled-components'
import { convertDate, initialName } from '../../function/function'
import ViewIcon from '../../../images/view-details.png'
import RejectIcon from '../../../images/remove.png'
import DenyIcon from '../../../images/multiply.png'
import SickIcon from '../../../images/medicine.png'
import FinishIcon from '../../../images/notepad-green.png'
import ApprIcon from '../../../images/quality.png'
import DoneIcon from '../../../images/check-blue.png'
import RptUplodaIcon from '../../../images/rpt_upload.png'
import reasonIcon from '../../../images/question.png'
import { baseUrl } from '../../../environment'
import DataStatus from '../../../data/status'

const CardItem = Styled.div`
    margin: 16px;
    border-radius: 12px;
    position: relative;
`

const RowCard = Styled.div`
    padding: 18px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const CircleUser = Styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    background: #08A0F7;
    color: #FFF;
    font-size: 12px;
    border-radius: 100%;
`

const LineCard = Styled.div`
    background: #C8DDEA;
    height: 1px;
`

let DS = new DataStatus()
const item_mobile = (props) => {
    const data = props.data
    
    let confirmStatus = data.flagStatus
    let formApplicant = data.formApplicant
    let salesUser = formApplicant.salesUser
    let hospital = formApplicant.hospital
    let hospitalName = (hospital) ? hospital.name : formApplicant.hospitalName

    let completionFile = data.uploadCompletions

    let date = data.bookingDate.replace(" ","T") 
    let bookDate = new Date(date)
    let currDate = new Date()
    let denyFlagId = DS.statusFlag()[2].id

    let startTime = data.startTime
    let reasonLeave = (data.confirmReason) ? data.confirmReason : (data.reasonLeave) ? data.reasonLeave : ""
    let approvedStatusId = DS.statusFlag()[0].id
    let doneStatusId = DS.statusFlag()[1].id

    const previewImage = () => {
        props.previewImage(completionFile)
    }
    
    return(
        <>
            <CardItem>
                {/* {
                    (confirmStatus.name == "DENY")
                    ?
                        <div style={{height: "100%", 
                            width: "100%", 
                            position: "absolute", 
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxSizing: "border-box", 
                            opacity: "0.2",
                            zIndex: "-1"}}>
                                <img src={RejectStamp} style={{width: "200px", transform: "rotate(-35deg)"}}/>
                        </div>
                    :
                        ""
                } */}

                {/* {
                    (confirmStatus.name == "SICK")
                    ?
                        <div style={{height: "100%", 
                            width: "100%", 
                            position: "absolute", 
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxSizing: "border-box", 
                            opacity: "0.2",
                            zIndex: "-1"}}>
                                <img src={SickStamp} style={{width: "200px", transform: "rotate(-35deg)"}}/>
                        </div>
                    :
                        ""
                } */}

                <div style={{padding: "7px 20px"}}>
                <RowCard>
                    {square}
                    {filter}
                </RowCard>
                <LineCard/>

                <RowCard>
                    <div style={{color: "#333333", fontSize: "14px"}}>
                        <CircleUser>
                            {initialName(salesUser.name)}
                        </CircleUser>
                    </div>
                    <div style={{color: "#949494", fontSize: "14px"}}>
                        {
                            salesUser.name
                        }
                    </div>
                </RowCard>
                <LineCard/>

                <RowCard>
                    <div style={{color: "#333333", fontSize: "14px"}}>
                        Rs Name
                    </div>
                    <div style={{color: "#949494", fontSize: "14px"}}>
                        {
                            
                            (hospitalName.length > 25)
                            ?
                                <div style={{maxWidth: "200px", textAlign: "justify", fontSize: "12px"}}>
                                    {hospitalName}
                                </div>
                            :
                                hospitalName
                        }
                    </div>
                </RowCard>
                <LineCard/>

                <RowCard>
                    <div style={{color: "#333333", fontSize: "14px"}}>
                        Contact Person
                    </div>
                    <div style={{color: "#949494", fontSize: "14px"}}>
                        {formApplicant.contactPerson}
                    </div>
                </RowCard>
                <LineCard/>

                <RowCard>
                    <div style={{color: "#333333", fontSize: "14px"}}>
                        Start Date
                    </div>
                    <div style={{color: "#949494", fontSize: "14px"}}>
                        {convertDate(data.bookingDate)}&nbsp;
                        {
                            (startTime != "00:00") ? startTime : ""
                        }
                    </div>
                </RowCard>
                <LineCard/>

                <RowCard>
                    <div style={{color: "#333333", fontSize: "14px"}}>
                        Status
                    </div>
                    <div style={{color: "#949494", fontSize: "14px"}}>
                        {
                            DS.statusFlag().map(dt => {
                                if(dt.id == confirmStatus.id)
                                return <button id="deny-sts" 
                                            style={{padding: "2px 5px", display: "flex", alignItems: "center" ,  background: "none", border: "none", outline: "none"}}>
                                            <img src={dt.icon} style={{width: "12px"}}/>&nbsp;
                                            <span style={{fontSize: "12px", color: dt.color, fontWeight: "bold"}}>{confirmStatus.name}</span>
                                        </button>
                            })
                        }
                        {/* {convertDate(data.finishActDate)} */}
                        {/* {
                            (confirmStatus.id == "00000000-0000-0000-0000-100000000060")
                            ?   <button id="deny-sts" style={{padding: "2px 5px", display: "flex", alignItems: "center" ,  background: "none", border: "none", outline: "none"}}>
                                    <img src={DenyIcon} style={{width: "12px"}}/>&nbsp;
                                    <span style={{fontSize: "12px", color: "#F00", fontWeight: "bold"}}>{confirmStatus.name}</span>
                                </button>
                            : ""
                        }
                        {
                            (confirmStatus.id == "00000000-0000-0000-0000-100000000030")
                            ?  
                                <button id="sick-sts" style={{padding: "2px 5px", display: "flex", alignItems: "center",  background: "none", border: "none", outline: "none"}}>
                                    <img src={SickIcon} style={{width: "12px"}}/>&nbsp;
                                    <span style={{fontSize: "12px", color: "#F00", fontWeight: "bold"}}>{confirmStatus.name}</span>
                                </button>
                            : ""
                        }
                        {
                            (confirmStatus.id == "00000000-0000-0000-0000-100000000070")
                            ?
                                <button id="done-sts" style={{padding: "2px 5px", display: "flex", alignItems: "center",  background: "none", border: "none", outline: "none"}}>
                                    <img src={DoneIcon} style={{width: "14px"}}/>&nbsp;
                                    <span style={{fontSize: "12px", color: "rgb(76 110 186)", fontWeight: "bold"}}>{confirmStatus.name}</span>
                                </button>
                            : ""
                        }
                        {
                            (confirmStatus.id == "00000000-0000-0000-0000-100000000050") 
                            ? 
                                <button id="fnsh-sts-act" style={{padding: "2px 5px", display: "flex", alignItems: "center", background: "none", border: "none", outline: "none"}}>
                                    <img src={ApprIcon} style={{width: "14px"}}/>&nbsp;
                                    <span style={{fontSize: "12px", color: "green", fontWeight: "bold"}}>{confirmStatus.name}</span>
                                </button>
                            : ""
                        }
                        {
                            (confirmStatus.id == "00000000-0000-0000-0000-100000000090")
                            ?   <div style={{color: "#E21B1B", fontSize: "12px", borderRadius: "5px", fontWeight: "bold", display: "flex", alignItems: "center"}}>
                                    <img src={DenyIcon} style={{width: "20px"}}/>&nbsp;&nbsp;{confirmStatus.name}
                                </div>
                            :   ""
                        } */}
                    </div>
                </RowCard>
                <LineCard/>
                
                {
                    <>
                    <RowCard>
                        <div style={{color: "#333333", fontSize: "14px"}}>
                            Completion
                        </div>
                        <div style={{color: "#949494", fontSize: "14px"}}>
                            {
                                (confirmStatus.id == denyFlagId)
                                ?
                                    <div id="bs-rsn-rw" style={{maxWidth: "120px", 
                                                fontSize: "11px", 
                                                fontWeight: "bold",
                                                padding: "5px", 
                                                border: "1px solid #CCC", 
                                                textAlign: "left", 
                                                margin: "auto", 
                                                wordBreak: "break-word",
                                                borderRadius: "5px"}}>
                                        <img src={reasonIcon} style={{width: "15px", position: "absolute", marginLeft: "-15px", marginTop: "-10px"}}/>
                                        {(reasonLeave != "") ? <span style={{color: "#000"}}>{reasonLeave}</span> : <span>No reason</span>}
                                    </div>
                                :
                                    (completionFile.length > 0)
                                    ?
                                        <a onClick={previewImage} style={{display: "flex"}}>
                                            <img style={{maxWidth: "40px", maxHeight: "40px", borderRadius: "5px"}} src={baseUrl+completionFile[0].url}/>
                                            {
                                                (completionFile.length > 1)
                                                ?
                                                    <div id="tip-sz-rpt-up" style={{border: "2px solid #CCC", 
                                                                background: "#FFF", 
                                                                fontSize: "10px",
                                                                marginLeft: "-5px",
                                                                marginTop: "-5px", 
                                                                height: "18px", 
                                                                width: "18px", 
                                                                display: "flex", 
                                                                alignItems: "center", 
                                                                borderRadius: "100%",
                                                                justifyContent: "center"}}
                                                    >
                                                        {completionFile.length - 1}+
                                                    </div>
                                                :
                                                    ""
                                            }
                                        </a>
                                    :
                                        ""
                            }
                        </div>
                        {/* <div style={{color: "#949494", fontSize: "14px"}}>
                            <a onClick={() => props.previewImage(baseUrl+completionFile[0].url)}>
                                <img src={baseUrl+completionFile[0].url} style={{maxWidth: "40px", maxHeight: "40px"}}/>
                            </a>
                        </div> */}
                    </RowCard>
                    <LineCard/>
                    </>
                }

                <RowCard>
                    <div style={{color: "#333333", fontSize: "14px"}}>
                        Action
                    </div>
                    <div style={{color: "#949494", fontSize: "14px", display: "flex"}}>
                        <Link to={"user_sales/"+formApplicant.formId}>   
                            <button  style={{padding: "2px 5px", display: "flex", alignItems: "center",background: "#FFF", border: "none", outline: "none"}}>
                                <img src={ViewIcon} style={{width: "12px"}}/>&nbsp;
                                <span style={{fontSize: "12px", color: "#000", fontWeight: "bold"}}>Details</span>
                            </button>
                        </Link>
                        {
                            (confirmStatus.name != "DENY" && (bookDate > currDate))
                            ?
                                <>
                                <>
                                &nbsp;&nbsp;
                                <button onClick={() => props.reject(data.scheduleId)}  style={{padding: "2px 5px", display: "flex", alignItems: "center", background: "none", border: "none", outline: "none"}}>
                                    <img src={RejectIcon} style={{width: "12px"}}/>&nbsp;
                                    <span style={{fontSize: "12x", color: "#F00", fontWeight: "bold"}}>Reject</span>
                                </button>
                                </>
                                </>
                            :
                                ""
                        }
                        {
                            (currDate >= bookDate && confirmStatus.id == approvedStatusId)
                            // (confirmStatus.id == "00000000-0000-0000-0000-100000000050")  
                            ? 
                                <button id="fnsh-sts-act" onClick={() => props.finish(data.scheduleId)} style={{padding: "2px 5px", display: "flex", alignItems: "center", background: "none", border: "none", outline: "none"}}>
                                <img src={FinishIcon} style={{width: "14px"}}/>&nbsp;
                                    <span style={{fontSize: "12px", color: "green", fontWeight: "bold"}}>Finish</span>
                                </button>
                            :   
                                (confirmStatus.id == doneStatusId && completionFile.length == 0)
                                ?
                                    <button id="fnsh-sts-act" onClick={() => props.finish(data.scheduleId)} style={{padding: "2px 5px", display: "flex", alignItems: "center", background: "none", border: "none", outline: "none"}}>
                                    <img src={RptUplodaIcon} style={{width: "14px"}}/>&nbsp;
                                        <span style={{fontSize: "12px", color: "green", fontWeight: "bold"}}>Upload</span>
                                    </button>
                                :   ""
                        }
                    </div>
                </RowCard>
                </div>
            </CardItem>
        </>
    )
}

const square = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6122 1.29187H5.38807C2.87057 1.29187 1.29224 3.07437 1.29224 5.59687V12.4035C1.29224 14.926 2.86224 16.7085 5.38807 16.7085H12.6114C15.1372 16.7085 16.7089 14.926 16.7089 12.4035V5.59687C16.7089 3.07437 15.1372 1.29187 12.6122 1.29187Z" stroke="#949494" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

const filter = <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.60851 10.8274H1.35791" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.95044 2.75035H14.201" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.27195 2.70521C5.27195 1.6255 4.39015 0.75 3.30266 0.75C2.21517 0.75 1.33337 1.6255 1.33337 2.70521C1.33337 3.78492 2.21517 4.66042 3.30266 4.66042C4.39015 4.66042 5.27195 3.78492 5.27195 2.70521Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.6667 10.7948C14.6667 9.7151 13.7856 8.8396 12.6981 8.8396C11.61 8.8396 10.7281 9.7151 10.7281 10.7948C10.7281 11.8745 11.61 12.75 12.6981 12.75C13.7856 12.75 14.6667 11.8745 14.6667 10.7948Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

const details = <svg width="86" height="24" viewBox="0 0 86 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 4C0 1.79086 1.79086 0 4 0H82C84.2091 0 86 1.79086 86 4V20C86 22.2091 84.2091 24 82 24H4C1.79086 24 0 22.2091 0 20V4Z" fill="#7784EE"/>
                    <path d="M29.6534 16C31.8693 16 33.1513 14.6257 33.1513 12.353C33.1513 10.0909 31.8693 8.72727 29.728 8.72727H27.299V16H29.6534ZM28.3963 15.0412V9.68608H29.6605C31.2514 9.68608 32.0717 10.6378 32.0717 12.353C32.0717 14.0753 31.2514 15.0412 29.593 15.0412H28.3963ZM36.7814 16.1101C37.9711 16.1101 38.8127 15.5241 39.0542 14.6364L38.0492 14.4553C37.8574 14.9702 37.3958 15.233 36.7921 15.233C35.883 15.233 35.2722 14.6435 35.2438 13.5923H39.1216V13.2159C39.1216 11.245 37.9426 10.4744 36.7069 10.4744C35.187 10.4744 34.1855 11.6321 34.1855 13.3082C34.1855 15.0021 35.1728 16.1101 36.7814 16.1101ZM35.2473 12.7969C35.29 12.0227 35.851 11.3516 36.714 11.3516C37.5378 11.3516 38.0776 11.9624 38.0811 12.7969H35.2473ZM42.8459 10.5455H41.7273V9.23864H40.6655V10.5455H39.8665V11.3977H40.6655V14.6186C40.6619 15.6094 41.4183 16.0888 42.2564 16.071C42.5938 16.0675 42.821 16.0036 42.9453 15.9574L42.7536 15.0803C42.6825 15.0945 42.5511 15.1264 42.3807 15.1264C42.0362 15.1264 41.7273 15.0128 41.7273 14.3984V11.3977H42.8459V10.5455ZM45.6078 16.1207C46.5098 16.1207 47.0176 15.6626 47.22 15.2543H47.2626V16H48.2995V12.3778C48.2995 10.7905 47.0495 10.4744 46.1831 10.4744C45.1958 10.4744 44.2868 10.8722 43.9316 11.8665L44.9295 12.0938C45.0858 11.7067 45.4835 11.3338 46.1973 11.3338C46.8826 11.3338 47.2342 11.6925 47.2342 12.3104V12.3352C47.2342 12.7223 46.8365 12.7152 45.8564 12.8288C44.823 12.9496 43.7647 13.2195 43.7647 14.4588C43.7647 15.5312 44.5708 16.1207 45.6078 16.1207ZM45.8386 15.2685C45.2385 15.2685 44.8052 14.9986 44.8052 14.473C44.8052 13.9048 45.3095 13.7024 45.9238 13.6207C46.2683 13.5746 47.085 13.4822 47.2377 13.3295V14.0327C47.2377 14.679 46.7228 15.2685 45.8386 15.2685ZM49.7138 16H50.7756V10.5455H49.7138V16ZM50.25 9.70384C50.6158 9.70384 50.9212 9.41974 50.9212 9.07173C50.9212 8.72372 50.6158 8.43608 50.25 8.43608C49.8807 8.43608 49.5788 8.72372 49.5788 9.07173C49.5788 9.41974 49.8807 9.70384 50.25 9.70384ZM53.2658 8.72727H52.204V16H53.2658V8.72727ZM58.7816 11.8771C58.5614 11.0284 57.8974 10.4744 56.7184 10.4744C55.4862 10.4744 54.6126 11.1243 54.6126 12.0902C54.6126 12.8643 55.0813 13.3793 56.104 13.6065L57.0273 13.8089C57.5529 13.9261 57.7979 14.1605 57.7979 14.5014C57.7979 14.924 57.3469 15.2543 56.6509 15.2543C56.0153 15.2543 55.6069 14.9808 55.479 14.4446L54.4528 14.6009C54.6303 15.5668 55.4329 16.1101 56.658 16.1101C57.9755 16.1101 58.8881 15.4105 58.8881 14.4233C58.8881 13.6527 58.3981 13.1768 57.3967 12.946L56.5302 12.7472C55.93 12.6051 55.6708 12.4027 55.6744 12.0334C55.6708 11.6143 56.1254 11.3161 56.729 11.3161C57.3896 11.3161 57.695 11.6818 57.8192 12.0476L58.7816 11.8771Z" fill="white"/>
                </svg>
export default item_mobile